export const SHIPMENTCARRIER_LOADING = "SHIPMENTCARRIER_LOADING";
export const SHIPMENTCARRIER_RESET = "SHIPMENTCARRIER_RESET";
export const GET_SHIPMENTCARRIER = "GET_SHIPMENTCARRIER";
export const GET_SHIPMENTCARRIER_SUCCESS = "GET_SHIPMENTCARRIER_SUCCESS";
export const GET_SHIPMENTCARRIER_FAIL = "GET_SHIPMENTCARRIER_FAIL";
export const DELETE_SHIPMENTCARRIER = "DELETE_SHIPMENTCARRIER"
export const DELETE_SHIPMENTCARRIER_SUCCESS = "DELETE_SHIPMENTCARRIER_SUCCESS"
export const DELETE_SHIPMENTCARRIER_FAIL = "DELETE_SHIPMENTCARRIER_FAIL"
export const UPDATE_SHIPMENTCARRIER = "UPDATE_SHIPMENTCARRIER"
export const UPDATE_SHIPMENTCARRIER_SUCCESS = "UPDATE_SHIPMENTCARRIER_SUCCESS"
export const UPDATE_SHIPMENTCARRIER_FAIL = "UPDATE_SHIPMENTCARRIER_FAIL"
export const ADD_NEW_SHIPMENTCARRIER = "ADD_NEW_SHIPMENTCARRIER"
export const ADD_SHIPMENTCARRIER_SUCCESS = "ADD_SHIPMENTCARRIER_SUCCESS"
export const ADD_SHIPMENTCARRIER_FAIL = "ADD_SHIPMENTCARRIER_FAIL"